module.exports = __webpack_public_path__ + "static/media/copy-btn.89693eea.svg";